import * as angular from 'angular';

import { WidgetWithErrors } from '../../widgets';
import { Helper } from '../../common';
import { IwidgetIntervalHelperService } from '../../services';
import { WidgetValuesReadConfiguration, ReadType, IBindable } from '../../models';
import { FlowChartConfiguration } from './flowChart.configuration';
import { FlowChartWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class FlowChartWidget extends WidgetWithErrors {
    baseType = definition.baseType;
    col = 0;
    configuration: FlowChartConfiguration;
    exportFormats = ['png', 'svg'];
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isDisabledMaximized = false;
    isExportable = true;
    isMaximizable = true;
    isMaximized = false;
    isZoomEnabled = true;
    map?: any;
    name = definition.title;
    row = 0;
    sizeX = 12;
    sizeY = 36;
    type = definition.type;

    constructor(
        private _$q: angular.IQService,
        intervalHelper: IwidgetIntervalHelperService
    ) {
        super(intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = new FlowChartConfiguration();
    }

    getSeriesGuids(): string[] {
        return this.configuration.series.map(d => d.guid);
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        return this.getReadConfigurationBase(beginDate, endDate, this.configuration.series, this.configuration, this.configuration.aggregation,
                                             true, false, false, false, false, ReadType.AggregatedValue, this.configuration.showAlarms);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = true;
                const hasMissingRanges = false;
                const hasContext = false;
                const hasTendency = false;
                const hasTarget = false;
                const aggregation = this.configuration.aggregation;
                const showLogbook = false;
                const hasAlarms = this.configuration.showAlarms;
                const widgetValuesReadConfiguration = this.createConfiguration(data, aggregation, hasQuality, hasMissingRanges, hasContext,
                                                                               hasTendency, hasTarget, ReadType.AggregatedValue, undefined, undefined, showLogbook, hasAlarms);
                return widgetValuesReadConfiguration;
            });
    }

    private getSeriesListAsync(): angular.IPromise<IBindable[]> {
        const result = this.configuration.series.map(d => {
            return {
                guid: d.guid,
                originalGuid: d.guid,
                value: d.value,
                //relativePath: d.relativePath,
                isBoundToGroup: d.isBoundToGroup
            };
        });
        return this._$q.when(result);
    }
}